import { Dispatch, SetStateAction } from 'react';
import { INightShift, IServiceCode, IWageCalculationComponent, IOvertimeLimits } from 'types/wage-calculation';
import IWorkhourSettings from 'types/wage-calculation/IWorkhourSettings';

interface ServiceCodesProps {
  companyId?: number;
}

interface ServiceCodeSchemasProps {
  setShouldUpdate: Dispatch<SetStateAction<boolean>>;
  setValidValues: Dispatch<SetStateAction<boolean>>;
}

interface ServiceCodesTableProps extends ServiceCodeSchemasProps {
  wageCalculationComponent: IWageCalculationComponent;
  setWageCalculationComponent: Dispatch<SetStateAction<IWageCalculationComponent>>;
}

interface ServiceCodesTableRowProps extends ServiceCodeSchemasProps {
  serviceCode: IServiceCode;
  setServiceCode: Dispatch<SetStateAction<IServiceCode>>;
  outcome: string;
}

interface NightShiftSchemaProps extends ServiceCodeSchemasProps {
  nightShiftRule: INightShift;
  setNightShiftRule: Dispatch<SetStateAction<INightShift>>;
}

interface OvertimeLimitsProps {
  overtimeLimits: IOvertimeLimits;
  setOvertimeLimits: Dispatch<SetStateAction<IOvertimeLimits>>;
  setShouldUpdate: Dispatch<SetStateAction<boolean>>;
  setValidValues: Dispatch<SetStateAction<boolean>>;
}

interface WorkhourSettingsProps {
  workhourSettings: IWorkhourSettings;
  setWorkhourSettings: Dispatch<SetStateAction<IWorkhourSettings>>;
  setShouldUpdate: Dispatch<SetStateAction<boolean>>;
  setValidValues: Dispatch<SetStateAction<boolean>>;
}

interface WorkScheduleFieldsProps {
  workingSystem: number | null;
  totalHours: string | number | null;
  allowEmptyTotalHours: boolean;
  // labels above the fields (the Fixed employment tab) instead of beside them
  stacked?: boolean;
  onChangeWorkingSystem: (workingSystem: number | null) => void;
  onChangeTotalHours: (totalHours: string, isValid: boolean) => void;
}

export enum ServiceCodesAction {
  UPDATE,
  RESET,
}

export enum OvertimeLimitsFields {
  DAILY = 'dailyLimit',
  WEEKLY = 'weeklyLimit',
}

export enum WorkhourSettingsFields {
  MIN_HOURS = 'minimumWorkhours',
  MAX_HOURS = 'maximumWorkhours',
}

export type {
  ServiceCodesProps,
  ServiceCodesTableProps,
  ServiceCodesTableRowProps,
  NightShiftSchemaProps,
  OvertimeLimitsProps,
  WorkhourSettingsProps,
  WorkScheduleFieldsProps,
};
